import { useCallback } from 'react';
import { useSelector } from 'react-redux';
import { loggerFunc } from 'utils/logger';
import { UserEventTracking } from 'services/MyRacService';

export const useCosmosTrackEvent = (loggerTag = 'Cosmos') => {
  const logger = loggerFunc(loggerTag);

  const { isAppView } = useSelector((state) => state.content.flags ?? {});
  const { PolicyNumber } = useSelector((state) => state.policy?.policyInfo ?? {});

  const cosmosTrackEvent = useCallback(
    async (eventType, eventData = {}) => {
      try {
        const event = {
          eventType,
          eventData: { isAppView, PolicyNumber, ...eventData },
        };

        const res = await UserEventTracking(event);

        if (res?.payload) {
          logger.debug(`"${eventType}" cosmos event tracked`);
          return true;
        }
      } catch (err) {
        if (loggerTag) {
          logger.debug(`Cosmos track event error for: "${eventType}":`, err);
        }
      }
      return false;
    },
    [logger, isAppView, PolicyNumber],
  );

  return { cosmosTrackEvent };
};

export default useCosmosTrackEvent;
